const firebaseConfig = {
    apiKey: "AIzaSyA5iSDXle2IEB7ADC4JlpT1b5VB2EkWdhc",
    authDomain: "travel-guru-1085b.firebaseapp.com",
    databaseURL: "https://travel-guru-1085b.firebaseio.com",
    projectId: "travel-guru-1085b",
    storageBucket: "travel-guru-1085b.appspot.com",
    messagingSenderId: "464766412133",
    appId: "1:464766412133:web:6c660ee7a71e7b3939ad8c"
  };
  export default firebaseConfig;